import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const dashboardPaths = {
  superadmin: "/superadmin/properties",
  property: "/propertyownerdashboard/properties",
  nonprofit: "/nonprofit/MyPropertyServices",
  realestate: "/realestatedashboard/properties",
  servicedashboard: "/servicedashboard/MyPropertyServices",
  HospitalManagment: "/Managed%20Care%20Organization's/Transportation",
};

const getCurrentDashboard = (pathname) => {
  const dashboard = Object.keys(dashboardPaths).find((key) =>
    pathname.includes(key)
  );
  console.log(dashboard);
  return dashboard || "superadmin"; // Default to superadmin if no match found
};

const Transportform = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    pickUpLocation: "",
    dropOffLocation: "",
    pickUpDate: "",
    pickUpTime: "",
    distance: "",
    companions: "",
    waitTime: "",
  });

  const [uploadFiles, setUploadFiles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleBreadcrumbClick = () => {
    const currentDashboard = getCurrentDashboard(location.pathname);
    const path = dashboardPaths[currentDashboard];
    navigate(path);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value || "",
    }));
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const newFiles = Array.from(files);
      console.log("Files added:", newFiles);
      setUploadFiles((prev) => [...prev, ...newFiles]);
    }
  };

  // handel submit
  const { formData: initialData = {}, formId, formType } = location.state || {};

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const token = localStorage.getItem("authToken");

    if (!token) {
      toast.error("Authentication token is missing. Please log in again.");
      setIsSubmitting(false);
      return;
    }

    try {
      // Step 1: Upload new files (if any)
      const newFiles = uploadFiles.filter((file) => file instanceof File);
      const filesURL = [];

      if (newFiles.length > 0) {
        const formDataForFiles = new FormData();
        newFiles.forEach((file) =>
          formDataForFiles.append("uploadFiles", file)
        );
        formDataForFiles.append("token", `"${token}"`);
        formDataForFiles.append(
          "foldername",
          "Service Provider | Transport Form | Files"
        );

        const uploadResponse = await axios.post(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/upload-file",
          formDataForFiles,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (!uploadResponse.data.status || !uploadResponse.data.filesURL) {
          throw new Error(uploadResponse.data.message || "File upload failed.");
        }

        filesURL.push(...uploadResponse.data.filesURL);
      }

      // Step 2: Include pre-filled image URLs
      const preFilledFiles = uploadFiles.filter(
        (file) => typeof file === "string"
      );
      filesURL.push(...preFilledFiles);

      // Step 3: Format pick-up time and prepare the payload
      const formattedPickUpTime = `${formData.pickUpDate}T${formData.pickUpTime}:00Z`;

      const payload = {
        transportFormData: {
          vehicleDetails: {
            ...formData,
            pickUpTime: formattedPickUpTime,
          },
          uploadFiles: filesURL,
        },
        token,
      };

      // Step 4: Submit the transportation form
      const response = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/transport-form/submit",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data.status) {
        toast.success("Transportation form submitted successfully!");
        resetForm();
      } else {
        throw new Error(
          response.data.error || "Failed to submit the transportation form."
        );
      }
    } catch (error) {
      console.error(
        "Error submitting transportation form:",
        error.response?.data || error.message
      );
      toast.error(
        error.response?.data?.message ||
          "An unexpected error occurred. Please try again later."
      );
    } finally {
      setIsSubmitting(false);
    }
  };
  // Reset form after successful submit or update
  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      phone: "",
      pickUpLocation: "",
      dropOffLocation: "",
      pickUpDate: "",
      pickUpTime: "",
      distance: "",
      companions: "",
      waitTime: "",
    });
    setUploadFiles([]);
  };

  const [isLoading, setIsLoading] = useState(true);

  // prefilled form data code
  useEffect(() => {
    if (formType === "Transport Form" && formId) {
      fetchFormData(formId);
    } else if (initialData?.serviceDetails) {
      setFormData(initialData.serviceDetails);
      setUploadFiles(initialData.uploadFiles || []);
    }
  }, [formId, formType, initialData]);

  const fetchFormData = async (formId) => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("authToken");

      const response = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/superadmin/transport-form/get-specific",
        { form_id: formId, token }
      );

      const formDataResponse = response.data?.form_data?.find(
        (item) => item._id === formId
      );

      if (formDataResponse) {
        setFormData(formDataResponse.vehicleDetails);
        setUploadFiles(formDataResponse.uploadFiles || []);
      } else {
        toast.error("Form data not found.");
      }
    } catch (error) {
      console.error("Error fetching form data:", error);
      toast.error("Unable to load form data.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveFile = (index) => {
    setUploadFiles((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <ToastContainer />
      <div className="w-[80vw] lg:w-full mx-auto rounded-lg p-6">
        <div className="w-full rounded-lg px-4 overflow-hidden">
          <div className="flex justify-start items-center border-b pb-2 mb-4">
            <div>
              <div className="mb-4 text-sm">
                <button
                  onClick={handleBreadcrumbClick}
                  className="text-gray-500 hover:text-gray-700"
                >
                  post a service / property
                </button>
                <span className="mx-2 text-gray-400">&gt;</span>
                <span className="text-purple-600 font-medium">
                  Transportation
                </span>
              </div>
              <h2 className="text-lg font-semibold">Transportation</h2>
            </div>
          </div>

          <div className="overflow-y-auto overflow-x-hidden">
            <h3 className="text-md font-medium mb-4">Vehicle Information</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              {[
                {
                  id: "name",
                  label: "Name",
                  type: "text",
                  placeholder: "Enter your name",
                },
                {
                  id: "email",
                  label: "Email",
                  type: "email",
                  placeholder: "Enter your email",
                },
                {
                  id: "phone",
                  label: "Phone",
                  type: "text",
                  placeholder: "Enter your phone",
                },
                {
                  id: "pickUpLocation",
                  label: "Pick Up Location",
                  type: "text",
                  placeholder: "Enter pick-up location",
                },
                {
                  id: "dropOffLocation",
                  label: "Drop Off Location",
                  type: "text",
                  placeholder: "Enter drop-off location",
                },
                { id: "pickUpDate", label: "Date", type: "date" },
                { id: "pickUpTime", label: "Time", type: "time" },
                {
                  id: "distance",
                  label: "Distance",
                  type: "text",
                  placeholder: "Enter distance",
                },
                {
                  id: "companions",
                  label: "Companions",
                  type: "text",
                  placeholder: "Enter companions",
                },
                {
                  id: "waitTime",
                  label: "Wait Time",
                  type: "text",
                  placeholder: "Enter wait time",
                },
              ].map(({ id, label, type, placeholder }) => (
                <div key={id}>
                  <label
                    htmlFor={id}
                    className="block mb-1 font-normal text-gray-700"
                  >
                    {label}
                  </label>
                  <input
                    type={type}
                    id={id}
                    placeholder={placeholder}
                    value={formData[id]}
                    onChange={handleInputChange}
                    className="border border-gray-300 rounded px-3 py-2 w-full"
                  />
                </div>
              ))}
            </div>

            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-800 mb-4">
                Upload Files
              </h3>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                <input
                  type="file"
                  multiple
                  onChange={handleFileChange}
                  className="hidden"
                  id="fileInput"
                />
                <label
                  htmlFor="fileInput"
                  className="cursor-pointer text-purple-600 font-semibold hover:underline"
                >
                  Browse Files
                </label>
                <div className="mt-4">
                  <p className="text-sm text-gray-600">
                    {uploadFiles.length > 0
                      ? `${uploadFiles.length} file(s) selected`
                      : "No files selected"}
                  </p>
                  {/* Display pre-filled images */}
                  <div className="flex flex-wrap gap-2 mt-4">
                    {uploadFiles.map((file, index) => (
                      <div key={index} className="relative">
                        {typeof file === "string" ? ( // Check if it's a URL (pre-filled image)
                          <img
                            src={file}
                            alt={`Uploaded file ${index}`}
                            className="w-20 h-20 object-cover rounded"
                          />
                        ) : (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`Uploaded file ${index}`}
                            className="w-20 h-20 object-cover rounded"
                          />
                        )}
                        <button
                          type="button"
                          onClick={() => handleRemoveFile(index)}
                          className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                        >
                          X
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <button
              onClick={handleSubmit}
              disabled={isSubmitting}
              className="bg-purple-700 h-10 w-full mt-4 mb-12 text-white"
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Transportform;
